import React from 'react';
import { ArcText } from '@src/core/ui';
import { BuildInfo, fetchBuildInfo } from '@src/core/config';
import { arcDateWithTime } from '@src/core/extensions';

// Readable readout of the deployed build, e.g.
//   v0.1.0 · staging · a1b2c3d · Jun 8, 2026, 12:22
// Sourced from build/version.json (see scripts/build.js).
const AppVersion: React.FC = () => {
  const [info, setInfo] = React.useState<BuildInfo | null>(null);

  React.useEffect(() => {
    let alive = true;
    fetchBuildInfo().then(data => {
      if (alive) setInfo(data);
    });
    return () => {
      alive = false;
    };
  }, []);

  if (!info) return null;

  const parts = [
    `v${info.version}`,
    info.branch,
    info.commit && info.commit !== '—' ? info.commit : null,
    info.buildNumber && info.buildNumber !== '—' ? `#${info.buildNumber}` : null,
    info.buildTime ? arcDateWithTime(info.buildTime) : null,
  ].filter(Boolean);

  return <ArcText.caption>{parts.join(' · ')}</ArcText.caption>;
};

export default AppVersion;
